

import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { CheckboxOptions, CheckboxDef } from '../../type'
import OptionFieldMixins from './OptionFieldMixins'

@Component
export default class CheckboxControl extends mixins(OptionFieldMixins) {
  get options () {
    return Object.assign(new CheckboxOptions(), this.def?.options)
  }

  onCheckBoxChange (row: any) {
    const fn = this.options?.onCheckBoxChange
    if (fn) fn(row, this.actualForm)
  }

  def!: CheckboxDef
}
